import React, {useEffect} from "react";
import {getProperty, ucFirst} from "@/Helpers/Function";
import {Breadcrumbs} from "@mui/material";
import Link from "@/Layouts/Link";

const BreadcrumbsComponent = (props) => {
    const {product = {}} = props;
    const {breadcrumbs = []} = product;

    useEffect(() => {
        const breadcrumbsApplication = breadcrumbs.map((el, i) => {
            const url = `/${getProperty(el, 'filterValueAlias')}`;
            return {
                "@type": "ListItem",
                "position": i + 2,
                "item": {
                    "@id": `${location.origin}/catalog${url}`,
                    "name": ucFirst(getProperty(el, 'filterValue'))
                }
            };
        });
        breadcrumbsApplication.unshift({
            "@type": "ListItem",
            "position": 1,
            "item": {
                "@id": `${location.origin}/catalog`,
                "name": 'Каталог'
            }
        });

        const application = document.createElement('script');
        application.type = 'application/ld+json';
        application.innerHTML = JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": breadcrumbsApplication
        });

        document.head.appendChild(application);
    }, [breadcrumbs]);

    return (
        <Breadcrumbs maxItems={4} itemsAfterCollapse={3} className={`breadcrumbs`}>
            <Link className={`breadcrumbs__link`} href={`/catalog`}>Каталог</Link>
            {breadcrumbs.map((el, i) => {
                const filterValue = getProperty(el, 'filterValue');

                const path = breadcrumbs
                    .slice(0, i + 1)
                    .map(breadcrumb => getProperty(breadcrumb, 'filterValueAlias'))
                    .join('/');

                // Возвращаем элемент списка со ссылкой на текущую категорию
                return (
                    <Link key={i} className={`breadcrumbs__link`} href={`/catalog/${path}`}>
                        {ucFirst(filterValue)}
                    </Link>
                );
            })}
        </Breadcrumbs>
    );
}

export default BreadcrumbsComponent;
